export interface ReturnPolicyResponse {
  receiptLookupPeriod: number;
}

export interface DateRange {
  startDate: Date;
  endDate: Date;
}

export interface ReactDateRangePickerDateRanges {
  range1: DateRange;
}

export enum ReturnsType {
  TransactionBasedReturn = 'TBR',
  NonReceiptReturn = 'NRR',
  GiftReceiptReturn = 'GRR',
  BottleDepositReturn = 'BDR',
  ReturnAllTransaction = 'All',
}
